import PropTypes from 'prop-types';
import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { ErrorMessage } from 'formik';

const QuestionField = ({ field, form: { touched, errors }, ...props }) => (
  <div>
    <InputTextarea
      {...field}
      {...props}
      className={touched[field.name] && errors[field.name] ? 'p-error' : ''}
      style={{ marginRight: '.25em' }}
    />
    <br />
    <ErrorMessage name={field.name} component="small" style={{ color: 'red' }} />
  </div>
);

QuestionField.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default QuestionField;
